/**
 * Initializes a password toggle button. When clicked, it toggles the type of input between
 * 'password' and 'text', so that the password is visible or not.
 *
 * @param {HTMLElement} container - The container element that contains the input whose type is
 *                                  to be toggled.
 * @returns {void}
 */
export default function initPasswordToggle(container) {
	const passwordInput = container.querySelector('input[type="password"]');
	if (passwordInput) {
		const toggleButton = document.createElement('button');
		toggleButton.type = 'button';
		toggleButton.className = 'password-toggle-btn';
		toggleButton.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-eye">
				<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
				<circle cx="12" cy="12" r="3"></circle>
			</svg>`;
		toggleButton.setAttribute('aria-label', 'Toggle password visibility');
        
		passwordInput.insertAdjacentElement('afterend', toggleButton);
        
		toggleButton.addEventListener('click', () => {
			if (passwordInput.type === 'password') {
				passwordInput.type = 'text';
				toggleButton.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-eye-slash">
						<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
						<line x1="1" y1="1" x2="23" y2="23"></line>
					</svg>`;
			} else {
				passwordInput.type = 'password';
				toggleButton.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-eye">
						<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
						<circle cx="12" cy="12" r="3"></circle>
					</svg>`;
			}
		});
	}
}
